import { render, staticRenderFns } from "./question-edit.vue?vue&type=template&id=0c320ade&scoped=true"
import script from "./question-edit.vue?vue&type=script&lang=ts"
export * from "./question-edit.vue?vue&type=script&lang=ts"
import style0 from "./question-edit.vue?vue&type=style&index=0&id=0c320ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c320ade",
  null
  
)

export default component.exports